import { styled, css } from 'styled-components'
import { ELEMENT_SIZE, MarginedDiv } from 'mixtiles-web-common'

const smallVariant = css`
  font-weight: 400;
  font-size: 14px;
  text-decoration-line: underline;
`

export const StyledMarginedDiv = styled(MarginedDiv)<{
  size?: keyof typeof ELEMENT_SIZE
  color?: string
}>`
  display: inline-block;
  cursor: pointer;
  font-weight: 700;
  font-size: 16px;
  color: ${({ color, theme }) => color || theme.colors.gray};
  ${({ size }) => size === ELEMENT_SIZE.small && smallVariant};
`
